export function initFormContact() {
  return [
    ...document.querySelectorAll(".b-form-contact:not(.-initialized)"),
  ].map((el) => {
    el.classList.add("-initialized");
    return new FormContact(el);
  });
}

export class FormContact {
  constructor(element) {
    this.element = element;
    this.init();
  }

  init() {
    this.customDropdown();
    this.customTooltip();
    this.setSourceSiteField();
    this.closeModal();
  }

  // New method to set the hidden field with current page URL
  setSourceSiteField() {
    // Find the hidden input field for SourceSite__c within this specific form
    const sourceSiteField = this.element.querySelector(
      'input[name="SourceSite__c"]'
    );

    if (sourceSiteField) {
      // Get the current page URL
      const currentUrl = window.location.href;

      // Set the value of the hidden field to the current URL
      sourceSiteField.value = currentUrl;
    }
  }

  customDropdown() {
    // Find selects only within this specific form
    const dropdowns = this.element.querySelectorAll(
      "select:not(.custom-dropdown-processed)"
    );

    dropdowns.forEach((dropdown) => {
      // Mark the dropdown as processed to prevent duplicates
      dropdown.classList.add("custom-dropdown-processed");

      // Create custom dropdown wrapper
      const wrapper = document.createElement("div");
      wrapper.className = "custom-dropdown-wrapper";

      // Create selected item display
      const selectedDisplay = document.createElement("div");
      selectedDisplay.className = "custom-dropdown-selected";

      // Create options list
      const optionsList = document.createElement("ul");
      optionsList.className = "custom-dropdown-options";

      // Hide original select
      dropdown.style.display = "none";

      // Populate selected display and options list
      const initialSelectedOption =
        dropdown.querySelector("option:checked") ||
        dropdown.querySelector("option");
      selectedDisplay.textContent = initialSelectedOption.textContent;

      // Create options
      Array.from(dropdown.options).forEach((option, index) => {
        const listItem = document.createElement("li");
        listItem.textContent = option.textContent;
        listItem.setAttribute("data-value", option.value);

        // Add selected class to the current selected option
        if (option === initialSelectedOption) {
          listItem.classList.add("selected");
        }

        listItem.addEventListener("click", () => {
          // Remove selected class from previous selected item
          const previousSelected = optionsList.querySelector(".selected");
          if (previousSelected) {
            previousSelected.classList.remove("selected");
          }

          // Add selected class to current item
          listItem.classList.add("selected");
          selectedDisplay.classList.add("filled");

          // Update original select
          dropdown.value = option.value;

          // Update selected display
          selectedDisplay.textContent = option.textContent;

          // Trigger change event on original select
          const event = new Event("change", { bubbles: true });
          dropdown.dispatchEvent(event);

          // Close dropdown
          wrapper.classList.remove("open");
        });

        optionsList.appendChild(listItem);
      });

      // Toggle dropdown
      selectedDisplay.addEventListener("click", (event) => {
        event.stopPropagation(); // Prevent event from bubbling
        wrapper.classList.toggle("open");
      });

      // Close dropdown when clicking outside
      const closeDropdown = (event) => {
        if (!wrapper.contains(event.target)) {
          wrapper.classList.remove("open");
        }
      };

      document.addEventListener("click", closeDropdown);

      // Assemble wrapper
      wrapper.appendChild(selectedDisplay);
      wrapper.appendChild(optionsList);

      // Insert wrapper before original select
      dropdown.parentNode.insertBefore(wrapper, dropdown);
    });
  }

  customTooltip() {
    const tooltipElements = this.element.querySelectorAll(".-has-tooltip");

    tooltipElements.forEach((element) => {
      const nextSibling = element.nextElementSibling;

      if (nextSibling && nextSibling.classList.contains("-tooltip")) {
        // Move tooltip inside .-has-tooltip
        element.appendChild(nextSibling);

        // Add tooltip icon if it doesn't exist
        if (!element.querySelector(".-tooltip-icon")) {
          const icon = document.createElement("i");
          icon.className = "-tooltip-icon mhc-icon mhc-icon-help-circle";
          icon.setAttribute("role", "button");
          icon.setAttribute("tabindex", "0");
          element.appendChild(icon);

          // Click event to toggle tooltip
          icon.addEventListener("click", (e) => {
            e.stopPropagation();
            nextSibling.classList.toggle("active");
          });
        }

        // Add close button inside tooltip if it doesn't exist
        if (!nextSibling.querySelector(".-tooltip-close")) {
          const closeBtn = document.createElement("i");
          closeBtn.className = "-tooltip-close mhc-icon mhc-icon-close";
          closeBtn.setAttribute("role", "button");
          closeBtn.setAttribute("tabindex", "0");
          nextSibling.appendChild(closeBtn);

          // Click event to close tooltip
          closeBtn.addEventListener("click", (e) => {
            e.stopPropagation();
            nextSibling.classList.remove("active");
          });
        }
      }
    });

    // Close tooltip when clicking outside
    document.addEventListener("click", (e) => {
      document.querySelectorAll(".-tooltip.active").forEach((tooltip) => {
        if (!tooltip.closest(".-has-tooltip")?.contains(e.target)) {
          tooltip.classList.remove("active");
        }
      });
    });
  }

  closeModal() {
    const modals = this.element.querySelectorAll(
      ".b-form-contact__confirmation"
    );
    if (modals) {
      modals.forEach((modal) => {
        const modalCloser = modal.querySelector(
          ".b-form-contact__confirmation__close"
        );
        modalCloser.addEventListener("click", () => {
          modal.classList.remove("-active");
        });
      });
    }
  }
}
